import { PLINKO_TEXTURE_KEYS } from './constants'

export const preLoadAssets = (scene: Phaser.Scene) => {
  const prefix = `/animations/plinko/`
  if (!scene.textures.getTextureKeys().includes(PLINKO_TEXTURE_KEYS.ATLAS)) {
    scene.load.multiatlas(
      PLINKO_TEXTURE_KEYS.ATLAS,
      `${prefix}atlas/animation-plinko-images.json`,
      `${prefix}atlas/`,
    )
  }
}
